"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stopwatch_1 = require("./internal/stopwatch");
var scheduler_1 = require("./internal/scheduler");
var windowInteraction_1 = require("./internal/windowInteraction");
var toSeconds_1 = require("./internal/utils/toSeconds");
var settings;
var stopwatch;
var scheduler;
var windowInteraction;
/**
 * @description Метод для подписки на время взаимодействия пользователя со страницей (см. README).
 */
function subscribe(params) {
    settings = params;
    var schedulerInterval = params.schedulerInterval, inactiveTime = params.inactiveTime;
    stopwatch = new stopwatch_1.Stopwatch();
    scheduler = new scheduler_1.Scheduler({ interval: schedulerInterval, job: job });
    windowInteraction = new windowInteraction_1.WindowInteraction({
        inactiveTime: inactiveTime,
        onActive: onActive,
        onInactive: onInactive,
        onVisible: onVisible,
        onHidden: onHidden,
    });
    windowInteraction.start();
    return function () {
        stopwatch.stop();
        scheduler.stop();
        windowInteraction.stop();
    };
}
exports.subscribe = subscribe;
function onVisible() {
    stopwatch.start();
    scheduler.start();
    debug(function () {
        var currentTime = toSeconds_1.toSeconds(stopwatch.getTime());
        return ['Страница стала видимой', "\u0421\u0435\u043A\u0443\u043D\u0434\u043E\u043C\u0435\u0440 \u0437\u0430\u043F\u0443\u0449\u0435\u043D. \u0412\u0440\u0435\u043C\u044F \u0441\u0442\u0430\u0440\u0442\u0430: " + currentTime + "c.", 'Планировщик запущен'];
    });
}
function onHidden() {
    var interactiveTime = stopwatch.stop();
    scheduler.stop();
    settings.subscriber({ interactiveTime: interactiveTime, isUserInitiator: true });
    debug(function () {
        var finalTime = toSeconds_1.toSeconds(interactiveTime);
        return [
            'Страница стала скрытой',
            "\u0421\u0435\u043A\u0443\u043D\u0434\u043E\u043C\u0435\u0440 \u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D. \u0412\u0440\u0435\u043C\u044F, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u043E\u0435 \u0432 \u0441\u043E\u0431\u044B\u0442\u0438\u0438: " + finalTime + "c.",
            'Планировщик остановлен',
        ];
    });
}
function onActive() {
    stopwatch.resume();
    scheduler.start();
    debug(function () {
        var currentTime = toSeconds_1.toSeconds(stopwatch.getTime());
        return ['Пользователь активен', "\u0421\u0435\u043A\u0443\u043D\u0434\u043E\u043C\u0435\u0440 \u0441\u043D\u044F\u0442 \u0441 \u043F\u0430\u0443\u0437\u044B. \u0422\u0435\u043A\u0443\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F: " + currentTime + "c.", 'Планировщик запущен'];
    });
}
function onInactive() {
    stopwatch.pause();
    scheduler.stop();
    debug(function () {
        var currentTime = toSeconds_1.toSeconds(stopwatch.getTime());
        var inactiveTime = toSeconds_1.toSeconds(settings.inactiveTime);
        return [
            "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435\u0430\u043A\u0442\u0438\u0432\u0435\u043D " + inactiveTime + "c.",
            "\u0421\u0435\u043A\u0443\u043D\u0434\u043E\u043C\u0435\u0440 \u043F\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D \u043D\u0430 \u043F\u0430\u0443\u0437\u0443. \u0422\u0435\u043A\u0443\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F: " + currentTime + "c.",
            'Планировщик остановлен',
        ];
    });
}
function job() {
    var interactiveTime = stopwatch.stop();
    settings.subscriber({ interactiveTime: interactiveTime, isUserInitiator: false });
    stopwatch.start();
    debug(function () {
        var currentTime = toSeconds_1.toSeconds(stopwatch.getTime());
        var finalTime = toSeconds_1.toSeconds(interactiveTime);
        var schedulerInterval = toSeconds_1.toSeconds(settings.schedulerInterval);
        return [
            "\u041F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0449\u0438\u043A \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u043B \u0437\u0430\u0434\u0430\u0447\u0443 \u0447\u0435\u0440\u0435\u0437 " + schedulerInterval + "c. \u0412\u0440\u0435\u043C\u044F, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u043E\u0435 \u0432 \u0441\u043E\u0431\u044B\u0442\u0438\u0438: " + finalTime + "c.",
            "\u0421\u0435\u043A\u0443\u043D\u0434\u043E\u043C\u0435\u0440 \u043F\u0435\u0440\u0435\u0437\u0430\u043F\u0443\u0449\u0435\u043D. \u0422\u0435\u043A\u0443\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F: " + currentTime + "c.",
        ];
    });
}
function debug(getLogs) {
    if (settings.debug) {
        var currentTime = new Date().toLocaleTimeString();
        console.group("[interactiveTime] " + currentTime);
        getLogs().forEach(function (log) { return console.info('[interactiveTime]', log); });
        console.groupEnd();
    }
}
//# sourceMappingURL=interface.js.map